import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const CategoryManage = () => {

  const navigate = useNavigate();

  const [getContactData, setContactData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH CATEGORY DATA
  // =========================

  useEffect(() => {
    fetchContactyData();
  }, []);

  const fetchContactyData = async () => {
    try {
      const res = await api.get("/adminAllpage/getContactData");
      setContactData(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Contact data");
    }
  };

  // =========================
  // DELETE CATEGORY
  // =========================

  const handleDelete = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete Contact?",
      text: "Do you want to delete this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {

      const res = await api.delete(
        `/adminAllpage/deleteContact/${id}`
      );

      if (res.data.success) {
        Swal.fire("Deleted!", "Data deleted successfully", "success");
        fetchContactyData();
      }

    } catch (error) {
      toast.error("Failed to delete");
    }

  };

  // =========================
  // STATUS CHANGE
  // =========================







  // =========================
  // PAGINATION
  // =========================

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentItems = getContactData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(getContactData.length / perPage);

  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Contact Us</h4>

        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-muted">
                    Data Not Found
                  </td>
                </tr>
              ) : (

                currentItems.map((cat, index) => (

                  <tr key={cat.tags_id}>

                    <td>{indexOfFirst + index + 1}</td>

                    <td>{cat.first_name}</td>

                    <td>{cat.phone}</td>
                     <td>{cat.email}</td>
                      <td>{cat.message}</td>

                    {/* ACTION */}
                    <td>
                    
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
               {currentItems.length === 0 ? (
               <></>
              ) : (
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>
              )}
      </div>

    </div>
  );
};

export default CategoryManage;